var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.223,
    height: 28.297,
    viewBox: "0 0 21.223 28.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_2_",
    "data-name": "pdf (2)",
    transform: "translate(-64 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16533",
    "data-name": "Group 16533",
    transform: "translate(64 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16532",
    "data-name": "Group 16532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38126",
    "data-name": "Path 38126",
    d: "M85.05,6.068l-5.9-5.9A.589.589,0,0,0,78.738,0H66.358A2.36,2.36,0,0,0,64,2.358V25.939A2.36,2.36,0,0,0,66.358,28.3H82.865a2.36,2.36,0,0,0,2.358-2.358V6.485A.589.589,0,0,0,85.05,6.068ZM79.328,2.013,83.21,5.9h-2.7a1.181,1.181,0,0,1-1.179-1.179Zm4.716,23.926a1.181,1.181,0,0,1-1.179,1.179H66.358a1.181,1.181,0,0,1-1.179-1.179V2.358a1.181,1.181,0,0,1,1.179-1.179h11.79V4.716a2.36,2.36,0,0,0,2.358,2.358h3.537Z",
    transform: "translate(-64)",
    fill: "#be0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38127",
    "data-name": "Path 38127",
    d: "M138.08,178.54a17.088,17.088,0,0,1-1.41-1.216c-.449-.449-.849-.884-1.2-1.3a13.2,13.2,0,0,0,.78-3c0-1.957-.707-2.358-1.769-2.358-.807,0-1.769.419-1.769,2.415a5.653,5.653,0,0,0,1.437,3.189c-.234.713-.508,1.536-.817,2.463-.149.445-.31.857-.48,1.238-.139.062-.273.124-.4.189-.469.234-.914.445-1.326.641-1.883.891-3.126,1.481-3.126,2.645,0,.845.918,1.368,1.769,1.368,1.1,0,2.751-1.464,3.96-3.93a23.45,23.45,0,0,1,4.047-1.092,6.763,6.763,0,0,0,2.6,1.485c1.462,0,1.769-.845,1.769-1.554,0-1.394-1.592-1.394-2.358-1.394A13.964,13.964,0,0,0,138.08,178.54Zm-8.311,5.1a.932.932,0,0,1-.59-.189c0-.418,1.246-1.009,2.452-1.58l.233-.11C130.979,183.04,130.1,183.636,129.769,183.636Zm4.127-10.555c0-1.235.383-1.235.59-1.235.417,0,.59,0,.59,1.179a9.452,9.452,0,0,1-.469,1.841A3.622,3.622,0,0,1,133.9,173.081Zm.452,6.336q.055-.154.107-.311c.219-.656.416-1.246.591-1.777q.367.4.791.828c.111.111.385.359.75.671C135.859,178.986,135.086,179.182,134.347,179.417Zm6.622.307c0,.265,0,.375-.547.378a4.345,4.345,0,0,1-.99-.565c.166-.018.289-.028.358-.028C140.661,179.509,140.908,179.594,140.969,179.724Z",
    transform: "translate(-124.463 -161.234)",
    fill: "#be0000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPdf);
export default __webpack_public_path__ + "static/media/View PDF.56e7e624.svg";
export { ForwardRef as ReactComponent };